.s-cart-summary{
  &-wrapper{

  }
  &-icon{

  }
  &-count{

  }
  &-total{
    
  }
}
